import React from "react";
import ThemeToggle from "./ThemeToggle";

const stats = [
    { value: "24/7", label: "Operations suivies" },
    { value: "120+", label: "Pays partenaires" },
    { value: "ERP", label: "Pilotage integre" },
];

const CardWrapper = ({ children }) => {
    return (
        <main className="soma-mco-login-page">
            <div className="soma-mco-login-theme">
                <ThemeToggle />
            </div>

            <section className="soma-mco-auth-shell" aria-label="Connexion SOMA Master">
                <aside className="soma-mco-auth-visual">
                    <div className="soma-mco-auth-brand">
                        <span className="soma-mco-auth-brand-mark">
                            <img src="/assets/img/login/soma-logo.png" alt="Logo SOMA Sarl" />
                        </span>
                        <div>
                            <strong>SOMA MASTER</strong>
                            <span>Enterprise operations</span>
                        </div>
                    </div>

                    <div className="soma-mco-auth-story">
                        <span className="soma-mco-auth-eyebrow">Direction generale</span>
                        <h1>Centre de controle logistique et financier.</h1>
                        <p>
                            Une interface unifiee pour suivre les operations, les finances, la paie,
                            la caisse, les approvisionnements et les equipes internes.
                        </p>
                    </div>

                    <div className="soma-mco-auth-stats">
                        {stats.map((item) => (
                            <article className="soma-mco-auth-stat" key={item.label}>
                                <strong>{item.value}</strong>
                                <span>{item.label}</span>
                            </article>
                        ))}
                    </div>
                </aside>

                <section className="soma-mco-auth-panel">
                    <div className="soma-mco-auth-panel-top">
                        <span>Acces securise</span>
                        <h2>Connexion</h2>
                        <p>Accedez a votre espace de gestion SOMA avec votre compte interne.</p>
                    </div>

                    {children}

                    <div className="soma-mco-auth-note">
                        <i className="bx bx-shield-quarter"></i>
                        <span>Transport, finance, RH, operations et communication dans une seule plateforme.</span>
                    </div>
                </section>
            </section>
        </main>
    );
};

export default CardWrapper;
